import { once } from "lodash";
import Intercom from "@intercom/messenger-js-sdk";
import { US_CITIZEN } from "@equidefi/constants/profile";

const APP_ID = "hyz6oa8h";

export const initialize = once(() => {
  Intercom({
    app_id: APP_ID,
  });
});

export const identify = once((user) => {
  Intercom({
    app_id: APP_ID,
    email: user.email,
    user_id: user.id,
    created_at: new Date().getTime(),
    user_hash: user.intercom_hmac,
  });
});

export const identifyWithMetadata = (user, metadata = {}) => {
  // Only send metadata in production environment
  if (process.env.NODE_ENV !== "production") {
    // Fall back to basic identification in non-production environments
    return identify(user);
  }

  try {
    const intercomData = {
      app_id: APP_ID,
      email: user.email,
      user_id: user.id,
      created_at: new Date().getTime(),
      user_hash: user.intercom_hmac,
    };

    // Add custom attributes if metadata is provided
    if (metadata && Object.keys(metadata).length > 0) {
      intercomData.custom_attributes = metadata;
    }

    Intercom(intercomData);
  } catch (error) {
    console.error("Intercom identification with metadata failed:", error);
    // Fall back to basic identification if enhanced version fails
    identify(user);
  }
};
